"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MERCHANT_CONFIG_DATA = exports.AUTHENTICATE_USER_ME = exports.AUTHENTICATE_USER_TOKENS = exports.AUTHENTICATE_USER_DATA = exports.PREFIX = void 0;
exports.PREFIX = '@VALEDASH';
exports.AUTHENTICATE_USER_DATA = "".concat(exports.PREFIX, ":AUTHENTICATE_USER_DATA");
exports.AUTHENTICATE_USER_TOKENS = "".concat(exports.PREFIX, ":AUTHENTICATE_USER_TOKENS");
exports.AUTHENTICATE_USER_ME = "".concat(exports.PREFIX, ":AUTHENTICATE_USER_ME");
exports.MERCHANT_CONFIG_DATA = "".concat(exports.PREFIX, ":MERCHANT_CONFIG_DATA");
